import type { ISpeakerProfile, TSpeakerEntryStatus } from "@lexicanon/shared"
import { Trans } from "@lingui/react/macro"
import { Badge, Group } from "@mantine/core"
import { IconMicrophone, IconSparkles, IconUserCheck } from "@tabler/icons-react"

interface IProps {
  /** Lifecycle status — drives the "needs ID" badge. */
  status: TSpeakerEntryStatus
  /** Recognition provenance — drives the voice-match / confirmed / AI-identified badge. */
  recognitionSource: ISpeakerProfile["recognition_source"]
}

/**
 * The row of speaker-status badges that lived VERBATIM in the SpeakerPanel and
 * MeetingSummaryView modal titles. Renders "needs ID" for an unidentified
 * speaker plus a provenance badge (voice match / confirmed / AI-identified) for
 * a recognised one. Dumb: derives everything from the two props.
 */
export function SpeakerStatusBadges({ status, recognitionSource }: IProps): React.JSX.Element {
  return (
    <Group gap="sm">
      {status === "unidentified" && (
        <Badge size="xs" color="warning" variant="light">
          <Trans>needs ID</Trans>
        </Badge>
      )}
      {recognitionSource === "voiceprint" && (
        <Badge size="xs" color="success" variant="light" leftSection={<IconMicrophone size={10} />}>
          <Trans>voice match</Trans>
        </Badge>
      )}
      {recognitionSource === "manual" && (
        <Badge size="xs" color="success" variant="light" leftSection={<IconUserCheck size={10} />}>
          <Trans>confirmed</Trans>
        </Badge>
      )}
      {recognitionSource === "llm" && (
        <Badge size="xs" color="info" variant="light" leftSection={<IconSparkles size={10} />}>
          <Trans>AI-identified</Trans>
        </Badge>
      )}
    </Group>
  )
}
